// Import Core Components here
import React from "react";

// Import App depedency here
import { Login } from "arv-extends";
import { Input, Img } from "arv-reactcomponents";
import { RegexMethods } from "npmlinks-constants";
import RequiredField from "../../RequiredField";

const { wrapper, getFinalComponent } = Login.UserNameInput;

class UserNameInput extends wrapper {
  get requiredFieldClassName() {
    const { isValid } = this.state;
    const { className } = this.props;
    return (this.props.required && `${className} ${isValid}`) || "";
  }

  get inputClassName() {
    const { isValid } = this.state;
    const { className } = this.props;
    return (!this.props.required && `${className} ${isValid}`) || "";
  }

  render() {
    const { userInputErrorMsg, userName, userNameErrorClass } = this.state;
    const {
      placeholder,
      name,
      showWarningIcon,
      showLoader,
      required,
      ...otherProps
    } = this.props;
    return (
      <div className="nw-username-input-container">
        <RequiredField
          className={this.requiredFieldClassName}
          required={required}
        >
          <Input
            className={this.inputClassName}
            name={name}
            onBlur={this.onBlur}
            onChange={this.validateUserName}
            onFocus={this.onFocus}
            placeholder={placeholder}
            type="text"
            value={userName}
            ref={values => {
              this.validateUserFieldRef = values;
            }}
            id="username-input"
            validateWithPattern={RegexMethods.USERNAME_REGEX}
            {...otherProps}
          />
        </RequiredField>
        {userInputErrorMsg !== "" && showWarningIcon && (
          <i className="icomoon-notification nw-input-warning-icon" />
        )}
        {showLoader && (
          <div className="nw-login-loader">
            <Img
              className="nw-username-loader"
              src="//static.nnnow.com/client/assets/images/icon/loader.gif"
              alt="loader"
            />
          </div>
        )}
        <div className={`nw-form-err-msg ${userNameErrorClass}`}>
          {userInputErrorMsg}
        </div>
      </div>
    );
  }
}

Login.UserNameInput.component = getFinalComponent(UserNameInput);
